import logo from './logo.svg';
import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import NewContactForm from './components/NewContactForm/NewContactForm';
import { history } from './history';
import './App.css';

function App() {
  if (history.location.pathname == '/') {
    return(
      <div className="landing">
      <h1 style={{color: "white"}}>Welcome to Givvy!</h1>
      <a style={{color: "white", background:"#d98fff"}} href="https://givvyapps.com/" className="btn">Go to Givvy Apps</a>
    </div>
    )
  } else {
    return (
      <div>
        <Routes history={history}>
          <Route exact path="/support/chatbot" element={<NewContactForm></NewContactForm>} />
          <Route exact path="/support/login" element={<NewContactForm></NewContactForm>} />
          <Route exact path="/support/contact" element={<NewContactForm></NewContactForm>} />
        </Routes>
      </div>
    );
  }

}

export default App;
